
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const bandit: Operator = {
	id: 'bandit',
	name: 'Bandit',
	role: 'Defender',
	org: 'GSG 9',
	squad: 'WOLFGUARD',
	ratings: {
		health: 1,
		speed: 3,
		difficulty: 1
	},
	meta: {
		gender: 'm',
		country: 'de',
		season: 'Release',
		height: 180,
		weight: 68,
		price: {
			renown: 1000,
			r6credits: 0
		}
	},
	bio: {
		real_name: 'Dominic Brunsmeier',
		birthplace: 'Berlin, Germany'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M305 305H184.56l-6.866-30.319-22.486 21.903-12.792-43L94.842 307.1l-8.315-81.71-41.489 44.042L45 45h260z" style="opacity:.4"></path><path d="M277 277h-60.737l14.154-30.417-37.194 38.083-9.222-37.778-23.667 25.278-13.161-44.853L103 277.01l-8.111-80.177L73 219.802V73h204z" style="fill:#fbbb3f"></path><path d="m243.667 3.75 65.944 33.528L183.25 238.625 161 186.5l-58 90.51 59.444-181.954 20.778 35.111z"></path><path d="M254.353 9.183 298.15 31.45 184.021 215.895l-19.91-54.34-54.403 101.715 54.375-145.326 19.972 33.611z" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-bandit'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
